'use client';

import { createContext } from 'react';

import type { TableHeaderCellContextInterface } from '../types/table-header-cell.types';

export const TableHeaderCellContext = createContext<TableHeaderCellContextInterface>({});

TableHeaderCellContext.displayName = 'Table.HeaderCell.Context';
